import { injectable } from "inversify"

import * as Api from "../constants/ApiUrlConstants"
import container from "../wires/Bootstrapper"
import SERVICE_IDENTIFIER from "../wires/Identifiers"

import { IApiService } from "./shared/ApiService"
import { IApiServiceExt } from "./shared/ApiServiceExt"

import { ModelBase } from "../models/ModelBase"
import { AccessoContiCorrentiModel, CategoriaEditModel, CategoriaModel, CategorieModel, ContiCorrentiModel, ContoCorrenteModel } from "../models/ConfigurazioneModels"
import { ConfigOpenBankingModel, ConfigFattureModel } from "../models/UtenteModels"
import { ImportFattureElettronicaModel } from "../models/ImportFattureElettronicaModel"
import { serializer } from "../components/shared/FormDataSerializer"

export interface IConfigurazioneService {
    GetContiCorrenti(): Promise<ContiCorrentiModel>
    SaveContoCorrente(data: ContoCorrenteModel): Promise<ModelBase>
    EliminaContoCorrente(id: string): Promise<ModelBase>
    GetCategorie(): Promise<CategorieModel>
    GetCategoria(id: string): Promise<CategoriaEditModel>
    SaveCategoria(data: CategoriaModel): Promise<ModelBase>
    EliminaCategoria(id: string): Promise<ModelBase>

    GetConfigFatture(Id: string): Promise<ConfigFattureModel>
    SaveConfigFatture(model: ConfigFattureModel): Promise<ConfigFattureModel>
    DeleteConfigFatture(Id: string): Promise<ModelBase>
    ImportConfigFatture(model: ConfigFattureModel): Promise<ModelBase>

    GetConfigOpenBanking(Id: string): Promise<ConfigOpenBankingModel>
    SaveConfigOpenBanking(model: ConfigOpenBankingModel): Promise<ConfigOpenBankingModel>
    DeleteConfigOpenBanking(Id: string): Promise<ModelBase>
    ImportConfigOpenBanking(model: ConfigOpenBankingModel): Promise<ModelBase>

    SetNrPeriodoList(periodo: string): Array<string>
    GetAccessoContiCorrenti(): Promise<AccessoContiCorrentiModel>
    ImportazioneFattureManuale(model: ImportFattureElettronicaModel): Promise<ImportFattureElettronicaModel>
}

@injectable()
export class ConfigurazioneService implements IConfigurazioneService {

    apiService: IApiService
    apiServiceExt: IApiServiceExt

    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE)
        this.apiServiceExt = container.get(SERVICE_IDENTIFIER.API_SERVICE_EXT)
    }

    async GetContiCorrenti(): Promise<ContiCorrentiModel> {
        return this.apiService.getAsync(Api.ConfigurazioneGetContiCorrenti, {})
    }
    async SaveContoCorrente(data: ContoCorrenteModel): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.ConfigurazioneSaveContoCorrente, data)
    }
    async EliminaContoCorrente(id: string): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.ConfigurazioneEliminaContoCorrente, { Id: id })
    }

    async GetCategorie(): Promise<CategorieModel> {
        return this.apiService.getAsync(Api.ConfigurazioneGetCategorie, {})
    }
    async GetCategoria(id: string): Promise<CategoriaEditModel> {
        return this.apiService.getAsync(Api.ConfigurazioneGetCategoria, { Id: id })
    }
    async SaveCategoria(data: CategoriaModel): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.ConfigurazioneSaveCategoria, data)
    }
    async EliminaCategoria(id: string): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.ConfigurazioneEliminaCategoria, { Id: id })
    }

    async GetConfigFatture(Id: string): Promise<ConfigFattureModel> {
        return this.apiService.getAsync(Api.ConfigurazioneGetConfigurazioneImportFatture, { Id })
    }

    async SaveConfigFatture(model: ConfigFattureModel): Promise<ConfigFattureModel> {
        return this.apiServiceExt.postAsync(Api.ConfigurazioneSaveConfigurazioneImportFatture, model)
    }

    async DeleteConfigFatture(Id: string): Promise<ModelBase> {
        return this.apiServiceExt.getAsync(Api.ConfigurazioneDeleteConfigurazioneImportFatture, { Id })
    }

    async ImportConfigFatture(model: ConfigFattureModel): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.ConfigurazioneImportConfigurazioneImportFatture, model)
    }

    async GetConfigOpenBanking(Id: string): Promise<ConfigOpenBankingModel> {
        return this.apiService.getAsync(Api.ConfigurazioneGetOpenBankingProvider, { Id })
    }

    async SaveConfigOpenBanking(model: ConfigOpenBankingModel): Promise<ConfigOpenBankingModel> {
        return this.apiServiceExt.postAsync(Api.ConfigurazioneSaveConfigurazioneOpenBanking, model)
    }

    async DeleteConfigOpenBanking(Id: string): Promise<ModelBase> {
        return this.apiServiceExt.getAsync(Api.ConfigurazioneDeleteConfigurazioneOpenBanking, { Id })
    }

    async ImportConfigOpenBanking(model: ConfigOpenBankingModel): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.ConfigurazioneImportConfigurazioneOpenBanking, model)
    }

    async ImportazioneFattureManuale(model: ImportFattureElettronicaModel): Promise<ImportFattureElettronicaModel> {
        debugger
        let preFormData = this.ConvertFiles(model)
        const formData = serializer(model, null, preFormData)
        //var result: Promise<ImportFattureElettronicaModel> = this.apiServiceExt.postAsync(Api.ConfigurazioneImportazioneFattureManuale, formData)
        return await this.apiServiceExt.postAsync(Api.ConfigurazioneImportazioneFattureManuale, formData);
    }

    // Quando passi di qui, controlla se il bug https://github.com/therealparmesh/object-to-formdata/issues/93 è stato risolto.
    // In tal caso, seguendo la risoluzione, è possibile eliminare la conversione manuale in form data della lista dei file
    private ConvertFiles(data: ImportFattureElettronicaModel): FormData {
        let formData = new FormData()
        if (data.Files)
            data.Files.forEach(e => formData.append('Files', e))

        return formData
    }

    SetNrPeriodoList(periodo: string): Array<string> {
        var nrPeriodi = []
        if (periodo.toLowerCase() == "settimanale")
            nrPeriodi = ["1", "2", "3"]
        if (periodo.toLowerCase() == "mensile")
            nrPeriodi = ["1", "2", "3", "4", "5", "6"]
        if (periodo.toLowerCase() == "annuale")
            nrPeriodi = ["1", "2"]
        return nrPeriodi
    }

    async GetAccessoContiCorrenti(): Promise<AccessoContiCorrentiModel> {
        return this.apiService.getAsync(Api.ConfigurazioneGetAccessoContiCorrenti, {})
    }
}